import { AppData } from './../../../services/app-data.service';
import { Assignee } from 'src/app/models/assignee';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-time-records',
    templateUrl: './time-records.component.html',
    styleUrls: ['./time-records.component.scss']
})
export class TimeRecordsComponent implements OnInit {

    public assignee: Assignee = this.appData.loggedInAssignee;

    constructor(
        private appData: AppData
    ) { 
	}

    ngOnInit() {

    }

}
